import React from "react";
import {
  Card,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  Typography
} from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import capitalize from "@material-ui/core/utils/capitalize";

export enum ApplyType {
  DAY = "DAY",
  WD_MONTH = "WD_MONTH",
  WD_YEAR = "WD_YEAR"
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      padding: "10px",
      display: "flex",
      justifyContent: "center"
    },
    label: {
      marginBottom: "10px"
    },
    controlLabel: {
      fontSize: "12px",
      textAlign: "center",
      width: "80px"
    }
  })
);

export const RadioButtonsGroup = (props: {
  callback: (value: string) => void;
  disabled: boolean;
}) => {
  const [value, setValue] = React.useState("DAY");
  const i18n = useTranslation();
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    props.callback(event.target.value);
  };
  const applyMethodTitle = i18n.t("hns:calendarDayType:applyMethodTitle");

  const singleDayTitle = capitalize(i18n.t("hns:calendarDayType:singleDay"));

  const weekdaysOfYearTitle = capitalize(
    i18n.t("hns:calendarDayType:weekdaysOfCurrentYear")
  );
  const weekdaysOfMonthTitle = capitalize(
    i18n.t("hns:calendarDayType:weekdaysOfCurrentMonth")
  );

  return (
    <Card className={classes.card}>
      <FormControl component="fieldset" disabled={props.disabled}>
        <FormLabel component="legend" className={classes.label}>
          {applyMethodTitle}
        </FormLabel>
        <RadioGroup
          row
          aria-label="apply type"
          name="applyType"
          value={value}
          defaultValue={ApplyType.DAY}
          onChange={handleChange}
        >
          <FormControlLabel
            value={ApplyType.DAY}
            control={<Radio color="primary" />}
            label={
              <Typography className={classes.controlLabel}>
                {singleDayTitle}
              </Typography>
            }
            labelPlacement="bottom"
          />
          <FormControlLabel
            value={ApplyType.WD_MONTH}
            control={<Radio color="primary" />}
            label={
              <Typography className={classes.controlLabel}>
                {weekdaysOfMonthTitle}
              </Typography>
            }
            labelPlacement="bottom"
          />
          <FormControlLabel
            value={ApplyType.WD_YEAR}
            control={<Radio color="primary" />}
            label={
              <Typography className={classes.controlLabel}>
                {weekdaysOfYearTitle}
              </Typography>
            }
            labelPlacement="bottom"
          />
        </RadioGroup>
      </FormControl>
    </Card>
  );
};
